import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { keyValidator } from 'src/app/common-components/auto-attendant-key-list/auto-attendant-key-list.component';
import { AutoAttendantKeyItemView } from 'src/app/common-components/auto-attendant-key-list/models/auto-attendant-key-item.model';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { ExtensionDetailView } from 'src/app/pages/extension-details/models/extension-detail-view.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-account-auto-attendant-keys',
    templateUrl: './add-account-auto-attendant-keys.component.html',
    standalone: false
})
export class AddAccountAutoAttendantKeysComponent implements FormComponent {
   form: UntypedFormGroup;

   keysFormArray: UntypedFormArray;

   addedExtensions: ExtensionDetailView[];

   constructor(
      public dialogRef: MatDialogRef<AddAccountAutoAttendantKeysComponent>,
      private fb: UntypedFormBuilder,
      @Inject(MAT_DIALOG_DATA) public data
   ) {
      this.form = this.fb.group({
         autoAttendantKeysArray: fb.array(
            data.addedKeys
               ? [
                    ...data.addedKeys.map((key) => {
                       return this.createKeyFormGroup(key);
                    }),
                 ]
               : [],
            keyValidator()
         ),
      });
      this.addedExtensions = data.addedExtensions;

      this.keysFormArray = this.form.get('autoAttendantKeysArray') as UntypedFormArray;
   }

   onCloseClick() {
      this.dialogRef.close();
   }

   onSubmit() {
      if (this.form.valid) {
         this.dialogRef.close(this.keysFormArray.value.filter((v) => !v.isDeleted));
      } else {
         this.form.markAllAsTouched();
      }
   }

   private createKeyFormGroup(key?: AutoAttendantKeyItemView): UntypedFormGroup {
      const formGroup = this.fb.group({
         autoAttendantKeyId: key?.autoAttendantKeyId,
         isDeleted: key?.isDeleted ?? false,
         keyNumber: this.fb.control(key?.keyNumber, keyValidator()),
         routeToExtension: this.fb.control(key?.routeToExtension),
         routeToNullAction: this.fb.control(key?.routeToNullAction),
         selectedOption: this.fb.control(key?.selectedOption),
      });

      return formGroup;
   }
}
